module.exports = __webpack_public_path__ + "img/qzfb.4028788f.png";